import React from 'react';
import {Box} from "@mui/material";
import {IconContext} from "react-icons";
import {IRaspberryPiIp} from "../../../../../../utils/interfaces/industry_machine/RaspberryPiPinLog/IRaspberryPiIp";
import {FaCircle} from "react-icons/fa";

const useCustomCellRenderer = (row: IRaspberryPiIp, theme: any) => {


    const getIconsForCustomField = (row: IRaspberryPiIp, theme: any) => {
        const iconColor = theme.palette.primary.main;

        return (
            <FaCircle color={row.is_active ? 'green' : 'red'}/>

        );
    };

    const renderIcons = () => {
        const icons = getIconsForCustomField(row, theme);
        return (
            <IconContext.Provider value={{size: "1.3rem"}}>
                <Box display="flex" sx={{gap: 0.5}}>
                    <span>{icons}</span>
                </Box>
            </IconContext.Provider>
        );
    };

    return {renderIcons};
};

export default useCustomCellRenderer;